import { render, staticRenderFns } from "./NotRegisteredNewSiteModal.vue?vue&type=template&id=9aa21196&scoped=true&"
import script from "./NotRegisteredNewSiteModal.vue?vue&type=script&lang=js&"
export * from "./NotRegisteredNewSiteModal.vue?vue&type=script&lang=js&"
import style0 from "./NotRegisteredNewSiteModal.vue?vue&type=style&index=0&id=9aa21196&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa21196",
  null
  
)

export default component.exports